import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReportEditorContainer from './ReportEditorContainer';
import { generateReport } from 'redux/report/ReportActions';

const mapStateToProps = ({ reports }) => ({
  generatingReport: reports.generatingReport,
  pageState: reports.pageState
});

const mapDispatchToProps = dispatch => ({
  reportsActions: bindActionCreators({ generateReport }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportEditorContainer);


// WEBPACK FOOTER //
// ./src/components/manageReports/comp/reportEditorContainer/ReportEditorContainerConnector.js